import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Link } from "@tanstack/react-router"
import { IconArrowLeftFill18 } from "nucleo-ui-fill-18"

import { PageHeader } from "@/components/common/page-header"
import { Button } from "@/components/ui/button"
import { EditOrganisationForm } from "@/features/admin/components/edit-organisation-form"
import { OrganisationLoginButton } from "@/features/admin/components/organisation-login-button"
import { adminOrganisationQueries } from "@/queries/admin-organisations"

export const Route = createFileRoute(
  "/_authenticated/admin/organisations/$organisationSlug/"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      adminOrganisationQueries.detail(params.organisationSlug)
    ),
  component: EditOrganisationPage,
})

function EditOrganisationPage() {
  const { organisationSlug } = Route.useParams()
  const { data: organisation } = useSuspenseQuery(
    adminOrganisationQueries.detail(organisationSlug)
  )

  return (
    <>
      <PageHeader
        title={organisation.name}
        actions={
          <>
            <Button
              variant="outline"
              nativeButton={false}
              render={
                <Link to="/admin/organisations">
                  <IconArrowLeftFill18 data-icon="inline-start" />
                  Organisations
                </Link>
              }
            />
            <OrganisationLoginButton organisation={organisation} />
          </>
        }
      />
      <div className="max-w-lg">
        <EditOrganisationForm organisation={organisation} />
      </div>
    </>
  )
}
